import {TEmailContextType} from './types';

export const defaultContext: TEmailContextType = {
    states: {
        emailEditor: null,
        personalizeState: null,
        imageState: null,
        hyperlinkState: null,
        language: null,
        treeValues: null,
        templates: {}
    }
};
